import React from "react";
import { Grid } from "semantic-ui-react";
import { StatCard } from "../StatCard";
import "./QuickStats.scss";

export function QuickStats(props) {
  const { overviewData } = props;

  if (!overviewData) return null;

  return (
    <Grid stackable className="dashboard-quick-stats">
      <Grid.Row columns={4}>
        <Grid.Column className="metric-column">
          <StatCard
            title="Estudiantes Activos"
            value={overviewData.totalActiveStudents || 0}
            icon="users"
            color="#2185d0"
            loading={!overviewData}
          />
        </Grid.Column>
        <Grid.Column className="metric-column">
          <StatCard
            title="Pagos Vencidos"
            value={overviewData.alerts?.overduePayments || 0}
            icon="exclamation triangle"
            color="#db2828"
            loading={!overviewData}
          />
        </Grid.Column>
        <Grid.Column className="metric-column">
          <StatCard
            title="Monto Cobrado"
            value={
              overviewData.revenue?.collected?.amount
                ? `S/ ${overviewData.revenue.collected.amount.toLocaleString()}`
                : "S/ 0"
            }
            icon="check circle"
            color="#21ba45"
            loading={!overviewData}
          />
        </Grid.Column>
        <Grid.Column className="metric-column">
          <StatCard
            title="Monto Pendiente"
            value={
              overviewData.revenue?.pending?.amount
                ? `S/ ${overviewData.revenue.pending.amount.toLocaleString()}`
                : "S/ 0"
            }
            icon="clock"
            color="#f2711c"
            loading={!overviewData}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
